import { useEffect, useContext } from 'react';
import {AuthContext} from "../bundles/auth/providers/AuthProvider";
import {useNavigate} from "react-router-dom";

export const AuthEventHandler = () => {
    const navigate = useNavigate();
    const { setAuthClaims } = useContext(AuthContext);

    useEffect(() => {
        const handleTokenInvalid = () => {
            setAuthClaims(null);
            navigate("/auth", { state: { logoutReason: 'session_expired' } });
        };

        authEvents.listenToTokenInvalid(handleTokenInvalid);

        return () => {
            authEvents.removeTokenInvalidListener(handleTokenInvalid);
        };
    }, [setAuthClaims]);

    return null; // This component doesn't render anything
};

export const authEvents = {
    onTokenInvalid: () => {
        const event = new Event('onTokenInvalid');
        window.dispatchEvent(event);
    },
    listenToTokenInvalid: (handler) => {
        window.addEventListener('onTokenInvalid', handler);
    },
    removeTokenInvalidListener: (handler) => {
        window.removeEventListener('onTokenInvalid', handler);
    }
};
